export default __webpack_public_path__ + "static/media/PastelGradientPreview.80da494c.webp";